module.exports = __webpack_public_path__ + "static/media/claim_dashboard_img.ea67c31d.png";